import { render, staticRenderFns } from "./pic-carousel.vue?vue&type=template&id=6a3d034e&scoped=true&"
import script from "./pic-carousel.vue?vue&type=script&lang=js&"
export * from "./pic-carousel.vue?vue&type=script&lang=js&"
import style0 from "./pic-carousel.vue?vue&type=style&index=0&id=6a3d034e&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d034e",
  null
  
)

export default component.exports